// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "物联网工程设计与实践",
      "tec": "周强",
      "week": "1-4,6-17单周",
      "add": "教学楼C座404管理"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "物联网工程设计与实践",
      "tec": "周强",
      "week": "1-4,6-17周",
      "add": "教学楼C座405管理"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
